import { flashes } from "@/mocks/chiguaHome";

export default function FlashTimeline() {
  return (
    <section id="flash" className="scroll-mt-20 border-y border-stone-200/70 bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-orange-700">
              <i className="ri-bubble-chart-line"></i> Flash Feed
            </span>
            <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-stone-900 md:text-3xl">
              快讯时间线 <span className="text-orange-600">·</span> 跟上讨论节奏
            </h2>
            <p className="mt-2 max-w-xl text-sm text-stone-500">
              按时间倒序整理近期高热度话题，标注来源与热度，方便快速定位到你想聊的那一条。
            </p>
          </div>
          <a href="#topics" className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-semibold text-orange-700 hover:text-orange-800">
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="relative mt-8 pl-0">
          {/* 纵向时间线 */}
          <div className="absolute bottom-4 left-[11px] top-2 hidden w-px bg-stone-200 sm:block"></div>

          <div className="flex flex-col gap-5">
            {flashes.map((f, i) => (
              <article
                key={f.title}
                className={`relative flex flex-col gap-4 rounded-xl border border-stone-200 bg-[#fdfbf6] p-4 sm:flex-row sm:items-center sm:pl-14 md:p-5 md:pl-16`}
              >
                {/* 时间节点 */}
                <div className="hidden sm:block sm:absolute sm:left-0 sm:top-1/2 sm:-translate-y-1/2">
                  <span className={`flex h-[22px] w-[22px] items-center justify-center rounded-full border-2 border-white ring-1 ring-orange-300 ${i === 0 ? "bg-orange-600" : "bg-white"}`}>
                    {i === 0 && <span className="h-1.5 w-1.5 rounded-full bg-white"></span>}
                  </span>
                </div>

                <div className="flex items-center gap-3 sm:hidden">
                  <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-bold ${i === 0 ? "bg-orange-600 text-white" : "bg-orange-100 text-orange-700"}`}>
                    {f.time}
                  </span>
                  <span className="text-xs font-semibold text-stone-500">{f.hot} 热度</span>
                </div>

                {f.image && (
                  <div className="h-36 w-full shrink-0 overflow-hidden rounded-lg sm:h-24 sm:w-40">
                    <img src={f.image} alt={f.title} className="h-full w-full object-cover" />
                  </div>
                )}

                <div className="min-w-0 flex-1">
                  <div className="mb-1.5 hidden items-center gap-2 sm:flex">
                    <span className="text-xs font-bold text-stone-400">{f.time}</span>
                    <span className="h-1 w-1 rounded-full bg-stone-300"></span>
                    <span className="text-xs font-semibold text-orange-700">{f.tag}</span>
                  </div>
                  <h3 className="text-sm font-bold text-stone-900 md:text-base">{f.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-stone-600 md:text-sm">{f.summary}</p>
                </div>

                <div className="flex shrink-0 items-center justify-between gap-3 sm:flex-col sm:items-end">
                  <span className="inline-flex items-center gap-1 rounded-full bg-stone-100 px-2 py-1 text-[11px] font-semibold text-stone-600">
                    <i className="ri-fire-line text-orange-500"></i> {f.hot}
                  </span>
                  <a href="#flash" className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-orange-700 hover:text-orange-800">
                    进讨论串 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}